import { createHttpClient, normalizeAxiosError } from '@akyga/shared-ui/httpClient';
import config from 'config/config';

export { normalizeAxiosError };

const httpClient = createHttpClient(config.API_BASE_URL);

export default httpClient;
